/**
 * TabsController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Navigation.TabsController = function () {
  var $tabs = $('.js-tabs');

  $tabs.responsiveTabs({
    setHash: true,
    animationQueue: false,
    load: function () {
      if ($(this).find('.grid--gridColor-theme').length !== 0) {
        $(this).addClass('tab--hasThemeColorGrid');
      }
    }
  });

  // Add anchor to image_archive links for nested tabs
  if ($('.image_archive').parents('.tabs-panel')) {
    var tabImageArchive = $('.image_archive').parents('.tabs-panel').attr('id');
    $('.image_archive .addAnchorToUrl').each(function () {
      $(this).attr('href', $(this).attr('href') + '#' + tabImageArchive);
    });
  }

  // Add anchor to banner links for nested tabs
  if ($('.banner-generator').parents('.tabs-panel')) {
      var tabBannerGenerator = $('.banner-generator').parents('.tabs-panel').attr('id');
      $('.banner-generator a').each(function () {
          $(this).data('uri', $(this).data('uri') + '#' + tabBannerGenerator);
      });
      $('.banner-generator form').each(function () {
        $(this).data('uri', $(this).data('uri') + '#' + tabBannerGenerator);
      });
  }

  // (TODO) Solr Tabs: This should be removed and implemented in fluid as soon as possible. Hint: Solr Version 7.0 should support fluidtemplating.
  if (!$('.tabs.solr-tabs .r-tabs-state-active').length) {
    $('.tabs.solr-tabs li:first').addClass('r-tabs-state-active');
  }
};
